import { parse, getHours, getMinutes } from 'date-fns';
import { OperatingHoursSettings } from 'pages/WorkflowBuilder/WorkflowBuilder.types';
import { WorkflowConfig } from 'pages/AgenticWorkflow/AgenticWorkflow.types';

const REF_DATE = new Date(0);

function timeToMinutes(timeStr: string): number {
    const d = parse(timeStr, 'HH:mm', REF_DATE);
    return getHours(d) * 60 + getMinutes(d);
}

function currentMinutesInTimezone(timezone: string): number {
    // Intl is required here because date-fns doesn't support timezone conversion
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(new Date());

    const hour = Number(parts.find((p) => p.type === 'hour')?.value ?? 0);
    const minute = Number(parts.find((p) => p.type === 'minute')?.value ?? 0);
    return hour * 60 + minute;
}

export function isOutsideOperatingHours(config?: WorkflowConfig): boolean {
    const oh = config?.operatingHours;
    if (!oh?.startTime || !oh?.endTime || !oh?.timezone) return false;

    try {
        const current = currentMinutesInTimezone(oh.timezone);
        const start = timeToMinutes(oh.startTime);
        const end = timeToMinutes(oh.endTime);

        if (start === end) return false;
        if (start > end) return current < start && current >= end;
        return current < start || current >= end;
    } catch {
        return false;
    }
}

export function formatOperatingHoursTooltip(oh: OperatingHoursSettings): string {
    return `Outside operating hours (${oh.startTime} – ${oh.endTime} ${oh.timezone})`;
}
